import React , { Component  } from 'react';
import './_input.css';
import { SendIcon } from '../Icons';
import Button from '../Button';

class Input extends Component{

    state={
        message : ''
    }

    _onTextChange = (message)=>{
        this.setState({message});
    }

    _onSubmitMessage = (evt)=>{
        evt.preventDefault();
        const { message } = this.state;
        if(!message) return;
            
        this.props.onSubmitMessage(message)
        this.setState({message:''})

    }

    render(){
        const { shouldInit } = this.props;
        return(
            <form className="input-container" onSubmit={this._onSubmitMessage.bind(this)}>
                <div className="conteudo-input">
                    <input type="text" placeholder="Digite uma mensagem..." onChange={({target})=>this._onTextChange(target.value)} value={this.state.message}/>
                    {/* <FaImage style={{fontSize:26,opacity:.3}}/>
                    <FaPaperclip style={{fontSize:26, opacity:.3}}/> */}
                    <span className="separador"></span>
                    <Button 
                        onClick={this._onSubmitMessage.bind(this)} 
                        style={{backgroundColor: 'transparent', marginRight: '2%'}}>
                        <SendIcon style={{backgroundColor: shouldInit ? 'grey' : null}}/>
                    </Button>
                </div>
            </form>
        )
    }
}


Input.defaultProps = {
    onSubmitMessage : ()=>{}
}

export default Input; 


// WEBPACK FOOTER //
// ./src/components/inputmensagem/Input.js